/**
 * OfflineQueueBadge — Badge fixo no rodapé mostrando ações pendentes de envio.
 * Aparece SOMENTE quando há itens na fila offline. Click → drena manualmente.
 */
import React, { useEffect, useState } from "react";
import { CloudOff, Loader2 } from "lucide-react";
import { subscribe, drain } from "../utils/offlineQueue";

export default function OfflineQueueBadge() {
  const [count, setCount] = useState(0);
  const [draining, setDraining] = useState(false);
  const [online, setOnline] = useState(typeof navigator === "undefined" ? true : navigator.onLine);

  useEffect(() => {
    const unsub = subscribe((q) => setCount(q.length));
    const onUp = () => setOnline(true);
    const onDown = () => setOnline(false);
    window.addEventListener("online", onUp);
    window.addEventListener("offline", onDown);
    return () => {
      unsub();
      window.removeEventListener("online", onUp);
      window.removeEventListener("offline", onDown);
    };
  }, []);

  if (count === 0) return null;

  const handleRetry = async () => {
    setDraining(true);
    try { await drain({ silent: false }); } finally { setDraining(false); }
  };

  return (
    <button
      onClick={handleRetry}
      disabled={draining || !online}
      data-testid="offline-queue-badge"
      className="fixed left-3 bottom-[88px] z-[60] bg-amber-500 hover:bg-amber-600 disabled:opacity-70 text-white rounded-full shadow-2xl flex items-center gap-2 px-3 py-2 text-xs font-bold"
    >
      {draining ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <CloudOff className="w-3.5 h-3.5" />}
      {online
        ? `${count} pendente${count === 1 ? "" : "s"} — tocar para enviar`
        : `${count} pendente${count === 1 ? "" : "s"} (offline)`}
    </button>
  );
}
